import React from 'react';
import { css } from '@emotion/react';
import { colors } from '../primitives/colors';
import Link from '../primitives/link';
import IconFacebook from '../../images/svg/facebook.svg';
import IconInstagram from '../../images/svg/instagram.svg';
import IconLinkedIn from '../../images/svg/linkedin.svg';
import IconTwitter from '../../images/svg/twitter.svg';

const franchiseFooterStyles = {
    subfooterSocialLinksMicrosite: css({
        display: 'flex',
        paddingTop: '12px',
        paddingBottom: '12px',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        '>:not([hidden])~:not([hidden])': {
            marginLeft: '32px',
        },
    }),
    subfooterSocialLinkLight: css({
        color: colors.shadesWhite,
        svg: {
            fill: colors.shadesWhite,
        },
    }),
    franchiseAddress: css({
        fontStyle: 'normal',
        display: 'block',
    }),
};

interface FranchiseFooterProps {
    links?: Array<{
        title?: string | null;
        links?: Array<{
            title?: string | null;
            url?: string | null;
            className?: string | null;
            sublinks?: Array<{
                title?: string | null;
                url?: string | null;
                className?: string | null;
                sublinks?: Array<{
                    title?: string | null;
                    url?: string | null;
                }>;
            }>;
        }> | null;
    }> | null;
    staticDisclaimerCopy?: string | null;
    dynamicFooterDisclaimers?: ReadonlyArray<{
        contentBefore?: string | null;
        content?: string | null;
        pageMatch?: string | null;
    }>;
    currentPath?: string;
    franchise?: {
        name?: string | null;
        addressHidden?: boolean | null;
        address?: {
            address?: string | null;
            addressExt?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
        } | null;
        socialMedia?: {
            linkedIn?: string | null;
            twitter?: string | null;
            instagram?: string | null;
            facebook?: string | null;
        } | null;
    } | null;
}

const FranchiseFooter: React.FC<FranchiseFooterProps> = ({ franchise }) => (
    <>
        {/* Social media links above footer - full width orange bar */}
        <div css={css({
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)',
            backgroundColor: colors.primaryOrange,
            marginBottom: '24px',
        })}
        >
            <div css={franchiseFooterStyles.subfooterSocialLinksMicrosite}>
                {franchise?.socialMedia?.linkedIn && (
                    <Link css={franchiseFooterStyles.subfooterSocialLinkLight} to={`https://linkedin.com/${franchise?.socialMedia?.linkedIn}`} target="_blank">
                        <IconLinkedIn />
                    </Link>
                )}
                {franchise?.socialMedia?.twitter && (
                    <Link css={franchiseFooterStyles.subfooterSocialLinkLight} to={`https://twitter.com/${franchise?.socialMedia?.twitter}`} target="_blank">
                        <IconTwitter />
                    </Link>
                )}
                {franchise?.socialMedia?.instagram && (
                    <Link css={franchiseFooterStyles.subfooterSocialLinkLight} to={`https://instagram.com/${franchise?.socialMedia?.instagram}`} target="_blank">
                        <IconInstagram />
                    </Link>
                )}
                {franchise?.socialMedia?.facebook && (
                    <Link css={franchiseFooterStyles.subfooterSocialLinkLight} to={`https://facebook.com/${franchise?.socialMedia?.facebook}`} target="_blank">
                        <IconFacebook />
                    </Link>
                )}
            </div>
        </div>

        {/* Franchise address - now rendered in FooterBase as the last column */}
    </>
);

export default FranchiseFooter;
